import type {CouponStatusValue} from '../../../types';

import {Chip} from '@ds/components';

import {COUPON_STATUS_CONFIG} from '../../../constants';

type CouponStatusProps = {
  value?: string;
};

const CouponStatus: React.FC<CouponStatusProps> = ({value}) => {
  const status = COUPON_STATUS_CONFIG[value as CouponStatusValue];

  return (
    <Chip
      label={status?.label ?? value ?? ''}
      variant="soft"
      color={status?.color ?? 'default'}
      size="sm"
      interactive={false}
    />
  );
};

export default CouponStatus;
